/**
 * Auto-select first variant with inventory for products with "continue selling" policy
 * This script runs after variant-picker.js loads and overrides the initial selection
 */

(function() {
  'use strict';

  function selectFirstAvailableVariant() {
    // Wait for variant picker to be initialized
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) {
      console.log('No variant picker found');
      return;
    }

    // Check if this is initial page load (no variant in URL)
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');

    if (variantFromUrl) {
      console.log('Variant in URL, skipping auto-selection');
      return;
    }

    // Get product data
    const productData = variantPicker.productData;
    if (!productData || !productData.variants) {
      console.log('No product data found');
      return;
    }

    const currentVariant = variantPicker.currentVariant;
    const firstVariant = productData.variants[0];

    console.log('🔍 Checking variant selection:', {
      currentVariantId: currentVariant?.id,
      currentInventory: currentVariant?.inventory_quantity,
      firstVariantId: firstVariant?.id,
      isFirstVariant: currentVariant?.id === firstVariant?.id
    });

    // Only auto-select if we're showing the first variant AND it has no inventory
    if (!currentVariant || currentVariant.id !== firstVariant.id) {
      console.log('Not first variant, skipping');
      return;
    }

    if (currentVariant.inventory_quantity > 0) {
      console.log('First variant has inventory, no need to change');
      return;
    }

    // Find first variant with inventory
    const variantWithInventory = productData.variants.find(v => v.inventory_quantity > 0);

    if (!variantWithInventory) {
      console.log('No variants with inventory found');
      return;
    }

    console.log('✅ Auto-selecting variant with inventory:', {
      id: variantWithInventory.id,
      title: variantWithInventory.title,
      inventory: variantWithInventory.inventory_quantity
    });

    // Update the variant picker to select this variant
    const variantIdInput = document.querySelector('[name="id"]');
    if (variantIdInput) {
      variantIdInput.value = variantWithInventory.id;
    }

    // Update the variant picker's current variant
    variantPicker.currentVariant = variantWithInventory;
    variantPicker.productData.current_variant_id = variantWithInventory.id;

    // Update all option selectors (dropdown, radio buttons, etc.)
    const pickerFields = variantPicker.querySelectorAll('[data-picker-field]');
    pickerFields.forEach((field, index) => {
      const optionValue = variantWithInventory.options[index];
      const fieldType = field.dataset.pickerField;

      if (fieldType === 'radio' || fieldType === 'button' || fieldType === 'color' || fieldType === 'image') {
        // Radio button style
        const input = field.querySelector(`input[value="${optionValue}"]`);
        if (input) {
          input.checked = true;
          // Trigger updateSelectedValue if it exists
          if (field.updateSelectedValue) {
            field.updateSelectedValue();
          }
        }
      } else {
        // Dropdown style
        const select = field.querySelector('select');
        if (select) {
          select.value = optionValue;
          // Trigger updateSelectedValue if it exists
          if (field.updateSelectedValue) {
            field.updateSelectedValue();
          }
        }
      }
    });

    // Update price, button state, etc.
    if (variantPicker.updatePrice) variantPicker.updatePrice();
    if (variantPicker.updateButton) variantPicker.updateButton(!variantWithInventory.available, "", false);
    if (variantPicker.updateProductMeta) variantPicker.updateProductMeta();
    if (variantPicker.hideSoldOutAndUnavailableOptions) variantPicker.hideSoldOutAndUnavailableOptions();
  }

  // Run after DOM is loaded and variant picker is initialized
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // Wait a bit for variant picker to fully initialize
      setTimeout(selectFirstAvailableVariant, 100);
    });
  } else {
    // DOM already loaded
    setTimeout(selectFirstAvailableVariant, 100);
  }
})();
